// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutSlider_wrapper__uRPCj","preview":"CheckoutSlider_preview__0i704"};